export enum PaymentTransactionReviewStatus {
  Completed = 0,
  Cancelled = 1,
  Failed = 2,
  Scheduled = 3,
  Pledged = 4,
  Reccuring = 5,
  Rescheduled = 6
}
